import { Pipe, PipeTransform } from '@angular/core';
import { Store } from '@ngrx/store';
import {nodeInputTypes} from '../config';
import {selectNodeTypesMap} from '../../../core';
import {tap} from 'rxjs/operators';

@Pipe({
  name: 'nodeName'
})
export class NodeNamePipe implements PipeTransform {

  allNodeTypes: {};

  constructor(private store: Store) {
      this.store.select(selectNodeTypesMap)
          .pipe(
            tap(nodeTypes => this.allNodeTypes = nodeTypes)
          ).subscribe();
  }

  transform(value: string): string {
      if (this.allNodeTypes[value]) {
          return this.allNodeTypes[value].title;
      }

      if (nodeInputTypes[value]) {
          return nodeInputTypes[value].title;
      }
      return 'Start';
  }

}
